module.exports = "/assets/4837c57b0782c2478f1e19bd5676c592.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/TY.png
// module id = 1873
// module chunks = 0